import {useRootSelector} from 'store';

export function useProfile() {
  return useRootSelector((state) => state.profile.worker);
}
